import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '@/views/Login/Login.vue'
// import Layout from '@/views/Layout/Layout.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      name: 'login',
      path: '/login',
      component: () => import(
        /* webpackChunkName: 'login' */ './views/Login/Login'
      ),
      props: true
    },
    {
      name: 'layout',
      path: '/',
      component: () => import(
        './views/Layout/Layout'
      ),
      props: true,
      children: [
        {
          name: 'main',
          path: '/main',
          props: true,
          component: () => import(
            './views/Fdc/Main'
          )
        },
        /**
         * Board
         */
        {
          path: '/fdc/dashboard/dashboard',
          name: 'dashboard',
          meta: {
            breadcrumbs: ['Board', 'Dashboard']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Dashboard/Dashboard' // TODO v1.0
          )
        },
        /**
         * Base Info
         */
        {
          path: '/fdc/base-info/fab-info',
          name: 'fab-info',
          meta: {
            breadcrumbs: ['Base Info', 'FAB Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/FabManager/FabManager'
          )
        },
        {
          path: '/fdc/base-info/group-info',
          name: 'group-info',
          meta: {
            breadcrumbs: ['Base Info', 'Group Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/base-info/group-param-info',
          name: 'group-param-info',
          meta: {
            breadcrumbs: ['Base Info', 'Group Param Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/base-info/eqp-info',
          name: 'eqp-info',
          meta: {
            breadcrumbs: ['Base Info', 'EQP Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/EqpManager/EqpManager'
          )
        },
        {
          path: '/fdc/base-info/eqp-event-info',
          name: 'eqp-event-info',
          meta: {
            breadcrumbs: ['Base Info', 'EQP Event Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/EventManager/EventManager'
          )
        },
        {
          path: '/fdc/base-info/eqp-recipe-info',
          name: 'eqp-recipe-info',
          meta: {
            breadcrumbs: ['Base Info', 'EQP Recipe Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/RecipeManager/RecipeManager'
          )
        },
        {
          path: '/fdc/base-info/eqp-param-info',
          name: 'eqp-param-info',
          meta: {
            breadcrumbs: ['Base Info', 'EQP Param Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/ParameterManager/ParameterManager'
          )
        },
        {
          path: '/fdc/base-info/eqp-context-info',
          name: 'eqp-context-info',
          meta: {
            breadcrumbs: ['Base Info', 'EQP Context Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/DataCollection/ContextMappingPlan/ContextMappingPlan'
          )
        },
        {
          path: '/fdc/base-info/virtual-parameter',
          name: 'virtual-parameter',
          meta: {
            breadcrumbs: ['Base Info', 'Virtual Parameter']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/EqpInfo/VirtualParameter/VirtualParameter' // TODO v1.0
          )
        },

        /**
         * Collection
         */
        {
          path: '/fdc/collection/data-collection-plan',
          name: 'data-collection-plan',
          meta: {
            breadcrumbs: ['Collection', 'Data Collection Plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/DataCollection/DataCollectionPlan/DataCollectionPlan'
          )
        },
        // {
        //   path: '/fdc/collection/data-summary-plan',
        //   name: 'data-summary-plan',
        //   meta: {
        //     breadcrumbs: ['Collection', 'Data Summary Plan']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Preprocessing/DataSummaryPlan/DataSummaryPlan'
        //   )
        // },
        {
          path: '/fdc/collection/event-collection-plan',
          name: 'event-collection-plan',
          meta: {
            breadcrumbs: ['Collection', 'Event Collection plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/DataCollection/EventCollectionPlan/EventCollectionPlan' // TODO v1.0
          )
        },
        {
          path: '/fdc/collection/trace-collection-plan',
          name: 'trace-collection-plan',
          meta: {
            breadcrumbs: ['Collection', 'Trace Collection plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/DataCollection/TraceCollectionPlan/TraceCollectionPlan' // TODO v1.0
          )
        },
        {
          path: '/fdc/collection/context-mapping-plan',
          name: 'context-mapping-plan',
          meta: {
            breadcrumbs: ['Collection', 'Context Mapping plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/DataCollection/ContextMappingPlan/ContextMappingPlan' // TODO v1.0
          )
        },
        /**
         * Preprocessing
         */
        {
          path: 'fdc/pre-processing/pre-processing-plan',
          name: 'pre-processing-plan',
          meta: {
            breadcrumbs: ['Preprocessing', 'Preprocessing Plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Preprocessing/PreprocessingPlan/PreprocessingPlan'
          )
        },
        {
          path: 'fdc/pre-processing/data-summary-plan',
          name: 'data-summary-plan',
          meta: {
            breadcrumbs: ['Preprosseing', 'Data Summary Plan']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Preprocessing/DataSummaryPlan/DataSummaryPlan'
          )
        },
        /**
         * Monitor
         */
        {
          path: '/fdc/monitor/dashboard',
          name: 'dashboard',
          meta: {
            breadcrumbs: ['Monitor', 'Dashboard']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Dashboard/Dashboard'
          )
        },
        {
          path: '/fdc/monitor/eqp-status-monitor',
          name: 'eqp-status-monitor',
          meta: {
            breadcrumbs: ['Monitor', 'EQP Status Monitor']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/RealTime/EqpStatusMonitor/EqpStatusMonitor'
          )
        },
        {
          path: '/fdc/monitor/realtime-monitor',
          name: 'realtime-monitor',
          meta: {
            breadcrumbs: ['Monitor', 'Realtime Monitor']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/RealTime/RealTimeMonitor/RealTimeMonitor'
          )
        },
        // {
        //   path: '/fdc/monitor/lot-history',
        //   name: 'lot-history',
        //   meta: {
        //     breadcrumbs: ['Monitor', 'Lot History']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/LotHistory/LotHistory'
        //   )
        // },
        {
          path: '/fdc/monitor/event-history',
          name: 'event-history',
          meta: {
            breadcrumbs: ['Monitor', 'Event History']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/EqpHistory/EqpHistory'
          )
        },
        // {
        //   path: '/fdc/monitor/eqp-alarm-history',
        //   name: 'eqp-alarm-history',
        //   meta: {
        //     breadcrumbs: ['Monitor', 'EQP Alarm History']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Report/AlarmAnalysisReport/AlarmAnalysisReport'
        //   )
        // },

        /**
         * Analysis
         */
        // {
        //   path: '/fdc/analysis/trend-analysis',
        //   name: 'trend-analysis',
        //   meta: {
        //     breadcrumbs: ['Analysis', 'Trend Analysis']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        {
          path: '/fdc/analysis/eqp-history',
          name: 'eqp-history',
          meta: {
            breadcrumbs: ['Analysis', 'EQP History']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/EqpHistory/EqpHistory' // TODO v1.0
          )
        },
        {
          path: '/fdc/analysis/lot-history',
          name: 'lot-history',
          meta: {
            breadcrumbs: ['Analysis', 'Lot History']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/LotHistory/LotHistory' // TODO v1.0
          )
        },
        {
          path: '/fdc/analysis/parameter-analysis',
          name: 'parameter-analysis',
          meta: {
            breadcrumbs: ['Analysis', 'Parameter Analysis']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/ParameterAnalysis/ParameterAnalysis'
          )
        },
        {
          path: '/fdc/analysis/summary-analysis',
          name: 'summary-analysis',
          meta: {
            breadcrumbs: ['Analysis', 'Summary Analysis']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/SummaryDataAnalysis/SummaryDataAnalysis'
          )
        },
        // {
        //   path: '/fdc/analysis/spc-analysis',
        //   name: 'spc-analysis',
        //   meta: {
        //     breadcrumbs: ['Analysis', 'SPC Analysis']
        //   },
        //   props: true,
        //   component: () => import(
        //     './views/Fdc/Spc/SpcAnalysis/SpcAnalysis.vue'
        //   )
        // },
        {
          path: '/fdc/analysis/multivariate-analysis',
          name: 'multivariate-analysis',
          meta: {
            breadcrumbs: ['Analysis', 'Multivariate Analysis']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/MultivariateAnalysis/MultivariateAnalysis'
          )
        },
        {
          path: '/fdc/analysis/eqp-comparison-analysis',
          name: 'eqp-comparison-analysis',
          meta: {
            breadcrumbs: ['Analysis', 'EQP Comparison Analysis']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Analysis/EqpComparison/EqpComparison'
          )
        },
        // {
        //   path: '/fdc/analysis/change-comparison-analysis',
        //   name: 'change-comparison-analysis',
        //   meta: {
        //     breadcrumbs: ['Analysis', 'Change Comparison Analysis']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        // {
        //   path: '/fdc/analysis/parameter-correlation-analysis',
        //   name: 'parameter-correlation-analysis',
        //   meta: {
        //     breadcrumbs: ['Analysis', 'Parameter Correlation Analysis']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },

        /**
         * Model
         */
        {
          path: '/fdc/model/set-point-model',
          name: 'set-point-model',
          meta: {
            breadcrumbs: ['Model', 'Set-Point Model']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Detection/SetPoint/SetPointDetection'
          )
        },
        {
          path: '/fdc/model/formula-model',
          name: 'formula-model',
          meta: {
            breadcrumbs: ['Model', 'Formula Model']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Detection/Formula/FormulaDetection'
          )
        },
        {
          path: '/fdc/model/multivariate-model',
          name: 'multivariate-model',
          meta: {
            breadcrumbs: ['Model', 'Multivariate Model']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Detection/Multivariate/MultivariateDetection'
          )
        },
        // {
        //   path: '/fdc/model/spc-rule',
        //   name: 'spc-rule',
        //   meta: {
        //     breadcrumbs: ['Model', 'SPC Rule']
        //   },
        //   props: true,
        //   component: () => import(
        //     './views/Fdc/Spc/SpcRuleManager/SpcRuleManager.vue'
        //   )
        // },
        // {
        //   path: '/fdc/model/spc-model',
        //   name: 'spc-model',
        //   meta: {
        //     breadcrumbs: ['Model', 'SPC Model']
        //   },
        //   props: true,
        //   component: () => import(
        //     './views/Fdc/Spc/SpcModelManager/SpcModelManager.vue'
        //   )
        // },
        {
          path: '/fdc/model/spc-rule-manager',
          name: 'spc-rule-manager',
          meta: {
            breadcrumbs: ['Model', 'SPC Rule Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Spc/SpcRuleManager/SpcRuleManager.vue' /* 다른 파일 들과는 다르게 참조하는 javascript filename 이 .script.js 가 아니어서 .vue 확장자 붙여 줘야함 */
          )
        },
        {
          path: '/fdc/model/spc-mail-manager',
          name: 'spc-mail-manager',
          meta: {
            breadcrumbs: ['Model', 'SPC Mail Manager']
          },
          props: true,
          component: () => import(
            './views/Fdc/Spc/SpcMailManager/SpcMailManager'
          )
        },
        {
          path: '/fdc/model/spc-model-manager',
          name: 'spc-model-manager',
          meta: {
            breadcrumbs: ['Model', 'SPC Model Manager']
          },
          props: true,
          component: () => import(
            './views/Fdc/Spc/SpcModelManager/SpcModelManager.vue'
          )
        },
        {
          path: '/fdc/model/spc-analysis',
          name: 'spc-analysis',
          meta: {
            breadcrumbs: ['Model', 'SPC Analysis']
          },
          props: true,
          component: () => import(
            './views/Fdc/Spc/SpcAnalysis/SpcAnalysis.vue'
          )
        },
        {
          path: '/fdc/model/spc-model-status',
          name: 'spc-model-status',
          meta: {
            breadcrumbs: ['Model', 'SPC Model Status']
          },
          props: true,
          component: () => import(
            './views/Fdc/Spc/SpcModelStatus/SpcModelStatus.vue'
          )
        },
        {
          path: '/fdc/model/fault-action-plan',
          name: 'fault-action-plan',
          meta: {
            breadcrumbs: ['Model', 'Fault Action Plan']
          },
          props: true,
          component: () => import(
            './views/Fdc/Detection/FaultActionPlan/FaultActionPlan'
          )
        },

        /**
         * OCAP
         */
        {
          path: '/fdc/ocap/eqp-ocap',
          name: 'eqp-ocap',
          meta: {
            breadcrumbs: ['OCAP', 'EQP OCAP']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/ocap/ocap-analysis',
          name: 'ocap-analysis',
          meta: {
            breadcrumbs: ['OCAP', 'OCAP Analysis']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/ocap/ocap-code',
          name: 'ocap-code',
          meta: {
            breadcrumbs: ['OCAP', 'OCAP Code']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/ocap/ocap-user-info',
          name: 'ocap-user-info',
          meta: {
            breadcrumbs: ['OCAP', 'OCAP User Info']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        /**
         * Report
         */
        // {
        //   path: '/fdc/report/ocap-report',
        //   name: 'ocap-report',
        //   meta: {
        //     breadcrumbs: ['Report', 'OCAP Report']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        // {
        //   path: '/fdc/report/ocap-statistics',
        //   name: 'ocap-statistics',
        //   meta: {
        //     breadcrumbs: ['Report', 'OCAP Statistics']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Report/FaultAnalysisReport/FaultAnalysisReport'
        //   )
        // },
        {
          path: '/fdc/report/fault-analysis-report',
          name: 'fault-analysis-report',
          meta: {
            breadcrumbs: ['Report', 'Fault Analysis Report']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Report/FaultAnalysisReport/FaultAnalysisReport'
          )
        },
        {
          path: '/fdc/report/eqp-alarm-history',
          name: 'eqp-alarm-history',
          meta: {
            breadcrumbs: ['Report', 'EQP Alarm History']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Report/AlarmAnalysisReport/AlarmAnalysisReport'
          )
        },
        {
          path: '/fdc/report/fault-action-history',
          name: 'fault-action-history',
          meta: {
            breadcrumbs: ['Report', 'Fault Action History']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Report/FaultActionHistory/FaultActionHistory'
          )
        },
        // {
        //   path: '/fdc/report/spc-statistics',
        //   name: 'spc-statistics',
        //   meta: {
        //     breadcrumbs: ['Report', 'SPC Statistics']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Spc/SpcModelStatus/SpcModelStatus.vue'
        //   )
        // },

        /**
         * Admin
         */
        // {
        //   path: '/fdc/admin/system-manager',
        //   name: 'system-manager',
        //   meta: {
        //     breadcrumbs: ['Admin', 'System Manager']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        // {
        //   path: '/fdc/admin/system-monitor',
        //   name: 'system-monitor',
        //   meta: {
        //     breadcrumbs: ['Admin', 'System Monitor']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        // {
        //   path: '/fdc/admin/info-change-history',
        //   name: 'info-change-history',
        //   meta: {
        //     breadcrumbs: ['Admin', 'Info Change History']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
        //   )
        // },
        {
          path: '/fdc/admin/host-manager',
          name: 'host-manager',
          meta: {
            breadcrumbs: ['Admin', 'Host Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Management/HostManager/HostManager'
          )
        },
        {
          path: '/fdc/admin/user-manager',
          name: 'user-manager',
          meta: {
            breadcrumbs: ['Admin', 'User Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/admin/menu-manager',
          name: 'menu-manager',
          meta: {
            breadcrumbs: ['Admin', 'Menu Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/developing' // TODO v1.0
          )
        },
        {
          path: '/fdc/admin/code-manager',
          name: 'code-manager',
          meta: {
            breadcrumbs: ['Admin', 'Code Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Management/CodeManager/CodeManager'
          )
        },
        // {
        //   path: '/fdc/admin/virtual-eap-manager',
        //   name: 'virtual-eap-manager',
        //   meta: {
        //     breadcrumbs: ['Admin', 'Virtual EAP Manager']
        //   },
        //   props: true,
        //   component: () => import(
        //     /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Management/VirtualManager/VirtualManager'
        //   )
        // },
        {
          path: '/fdc/admin/virtual-manager',
          name: 'virtual-manager',
          meta: {
            breadcrumbs: ['Admin', 'Virtual Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Management/VirtualManager/VirtualManager'
          )
        },

        {
          path: '/fdc/admin/eqp-alarm-manager',
          name: 'eqp-alarm-manager',
          meta: {
            breadcrumbs: ['Admin', 'EQP Alarm Manager']
          },
          props: true,
          component: () => import(
            /* webpackChunkName: 'eap-sml-editor' */ './views/Fdc/Management/EqpAlarmManager/EqpAlarmManager'
          )
        },

        {
          name: 'dynamic-layout',
          path: '/fdc/dynamic-layout/dynamic-layout',
          props: true,
          component: () => import(
            './views/DynamicLayout/DynamicLayout'
          )
        },
        {
          name: 'custom-layout',
          path: '/fdc/dynamic-layout/custom-layout',
          props: true,
          component: () => import(
            './views/DynamicLayout/CustomLayout'
          )
        },
        {
          name: 'be-modal-test',
          path: '/fdc/be-modal-test',
          props: true,
          component: () => import(
            './views/BeModalTest'
          )
        },
        {
          name: 'button-sample',
          path: '/component-sample/button-sample',
          props: true,
          component: () => import(
            './views/ComponentSample/ButtonSample/ButtonSample.vue'
          )
        }, {
          name: 'modal-sample',
          path: '/component-sample/modal-sample',
          props: true,
          component: () => import(
            './views/ComponentSample/ModalSample/ModalSample.vue'
          )
        }, {
          name: 'loadingbar-sample',
          path: '/component-sample/loadingbar-sample',
          props: true,
          component: () => import(
            './views/ComponentSample/LoadingBarSample/LoadingBarSample.vue'
          )
        }, {
          name: 'chart-sample',
          path: '/component-sample/chart-sample',
          props: true,
          component: () => import(
            './views/ComponentSample/ChartSample/ChartSample.vue'
          )
        }, {
          name: 'grid-sample',
          path: '/component-sample/grid-sample',
          props: true,
          component: () => import(
            './views/ComponentSample/GridSample/GridSample.vue'
          )
        }, {
          name: 'auto-encoder-analysis',
          path: '/component-sample/auto-encoder-analysis',
          props: true,
          component: () => import(
            './views/ComponentSample/AutoEncoderAnalysis/AutoEncoderAnalysis.vue'
          )
        }
      ] // end layout-children
    } // end layout
  ]
})
